import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash-es/get';
import styled from 'styled-components';
import { connect } from 'react-redux';
import chunk from 'lodash-es/chunk';
import { Box, Heading, Text, Button } from '@components/common';
import { MobileContainer, DesktopContainer } from '@containers/layout';
import ScheduleActions from '@redux/ScheduleRedux';
import { AppSelectors } from '@redux/AppRedux';
import { DragSelectors } from '@redux/DragRedux';
import { BookingSelectors } from '@redux/BookingRedux';
import AddonBoardView from './AddonBoardView';
import DropContainer from '@components/draggable/DropContainer';
import AddonSelector from './AddonSelector';

const DesktopWrapper = styled(DesktopContainer)`
  @media screen and (max-width: 767px) {
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
`;

const ContainerView = styled(MobileContainer)`
  align-self: flex-start;
  align-items: stretch;
  z-index: 100;
  @media screen and (max-width: 767px) {
    flex: 0;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    padding-top: 0px;
  }
  @media screen and (min-width: 1024px) {
    padding-top: 0px;
  }
`;

const MobileOnly = styled(Box)`
  width: 100%;
  @media screen and (min-width: 1024px) {
    display: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    display: none;
  }
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const DesktopOnly = styled(Box)`
  width: 100%;
  @media screen and (max-width: 767px) {
    display: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    display: block;
  }
  @media screen and (min-width: 1024px) {
    display: block;
  }
`;

const RowRapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media screen and (max-width: 767px) {
    flex-direction: row;
  }
`;

const DraggableWrapper = styled(Box)`
  position: relative;
`;

const DropContainerWrapper = styled(DropContainer)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

function AddonRecurring(props) {
  const {
    addonData,
    setItemSelected,
    isRemovableDragging,
    onSubmit,
    propertyInfo
  } = props;

  const totalAddonTypes = Object.keys(addonData);
  const addonTypeGroups = chunk(totalAddonTypes, 2);

  return (
    <DesktopWrapper>
      <MobileOnly>
        <Button my={2} width={1} type="button" onClick={onSubmit}>
          Continue
        </Button>
      </MobileOnly>
      <AddonBoardView flex={1} />
      <ContainerView style={{ zIndex: isRemovableDragging ? -1 : 100 }}>
        <Box position="relative" pt={[4, 0]}>
          <Heading display={['none', 'block']} px={2} mb={4} mt={0}>
            Additional Services
          </Heading>

          <Text px={2} mb={4} textAlign={['center', 'left']}>
            What else can we take off your hands? Drag and drop to add to your
            schedule.
          </Text>
          <DraggableWrapper className="drag-remove-container">
            {addonTypeGroups.map(group => {
              if (!group.length > 0) {
                return null;
              }
              const key = `addon_on_recurring_group_${group[0]}`;
              return (
                <RowRapper key={key} px={2} mb={4}>
                  {group.map(addonType => (
                    <AddonSelector
                      data={addonData[addonType]}
                      addonType={addonType}
                      price={get(propertyInfo, `addons.${addonType}`, 0)}
                      onDrop={(row, col) => {
                        if (row === -1 || col === -1) {
                          return;
                        }
                        setItemSelected(row, col, addonType);
                      }}
                      key={addonType}
                    />
                  ))}
                </RowRapper>
              );
            })}

            {isRemovableDragging && (
              <DropContainerWrapper title="Remove Additional Service" />
            )}
          </DraggableWrapper>
        </Box>
        <DesktopOnly>
          <Button my={2} width={1} type="button" onClick={onSubmit}>
            Continue
          </Button>
        </DesktopOnly>
      </ContainerView>
    </DesktopWrapper>
  );
}

AddonRecurring.propTypes = {
  addonData: PropTypes.object,
  setItemSelected: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  isRemovableDragging: PropTypes.bool,
  propertyInfo: PropTypes.object
};

const mapStatesToProps = state => ({
  addonData: AppSelectors.selectAddonData(state),
  isRemovableDragging: DragSelectors.selectIsRemovableDragging(state),
  propertyInfo: AppSelectors.selectPropertyInfoOf(
    state,
    BookingSelectors.selectCurrentProperty(state)
  )
});

const mapDispatchToProps = dispatch => ({
  setItemSelected: (row, col, addon) =>
    dispatch(
      ScheduleActions.attachAddonToItem({
        row,
        col,
        addon
      })
    )
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(AddonRecurring);
